import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const useStyles = makeStyles(fillInTheBlanksStyles)

export default function FillInTheBlanks ({assessment, context, question}) {

  const classes = useStyles()

  const {answer = {}} = question
  const {phrases = []} = answer

  return (<Box className={classes.root}>
    <Box className={classes.studentAnswer}>
      <Box className={classes.wrapper}>
        {phrases.map(({phrase, blanked}, index) => {
          const text = blanked ? phrase.split('').map((_,i) => (<span key={i} className={classes.space} />)) : phrase
          return (<Box key={index} className={clsx(classes.phrase, {blanked})}>{text}</Box>)})
        }
      </Box>
    </Box>
  </Box>)

}


function fillInTheBlanksStyles (theme) {
  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    phrase: {
      ...verticalCentering,
      marginRight: 10,
      '&:last-child': {
        marginLeft: 0
      },
      '&.blanked': {
        display: 'flex',
        flexDirection: 'row',
        borderBottom: 'solid 1px black'
      },
    },
    space: {
      width: 15
    },
  }
}
